import 'arrive';
import Swiper from 'swiper/bundle';

function clamp(min, val, max) {
  return Math.min(Math.max(val, min), max);
}

function getSwiperGap() {
  return clamp(20, window.innerWidth * 0.0167, 32); 
}

document.arrive('.block-cards-cta', { existing: true }, function (el) {
  const container = el.querySelector('.swiper');
  if (!container || container.dataset.swiperInitialized === 'true') return;

  container.dataset.swiperInitialized = 'true';

  const swiper = new Swiper(container, {
    slidesPerView: 1.15,
    spaceBetween: getSwiperGap(),
    loop: false,
    freeMode: true,
    allowTouchMove: true,
    breakpoints: {
      550: { slidesPerView: 2.2 },
      850: { slidesPerView: 3.2 },
    },
  });

  // aggiorna il gap al resize
  window.addEventListener('resize', () => {
    swiper.params.spaceBetween = getSwiperGap();
    swiper.update();
  });
});